import * as React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
	dialogContent: {
		fontSize: "11pt",
		"& h1": {
			paddingBottom: "11pt"
		},
		"& p": {
			paddingBottom: "11pt"
		},
		"& ul": {
			listStyleType: "disc",
			paddingLeft: "30px",
		},
		"& ol": {
			listStyleType: "decimal",
			paddingLeft: "30px",
		},
		"& [contenteditable='true']": {
			display: "inline-block",
			fontWeight: "bold",
			background: "#efefef",
			minWidth: "130px",
			padding: "4px",
		},
		"& .error[contenteditable='true']": {
			background: "#f3bfbf",
		}
	}
});

interface IProps {

}

export default function HtmlContentStyled(props: React.PropsWithChildren<IProps>) {
	const classes = useStyles();
	return <div className={classes.dialogContent}>
		{props.children}
	</div>
}